import PreviewViewNotMappedStatus from '../views/view-not-mapped-status.html';
class studentParentMapping {
    constructor($scope, $mdDialog, $state, $mdMedia, $timeout, 
        localStorageService, authService, CONSTANTS, $rootScope) {
        'ngInject';
        
        let self = this;
        /** @Author: Naveen Nazimudeen N  @Date: 2018-02-23 15:17:34  @Desc: For url authorisation --starts */
        // localStorageService
        // UserPrivilages.getUserPrivilageInitialSetting(function(result) {
        //         let userAccessJson = UserPrivilages.getFeatures("userEndorsement");
        //         if (userAccessJson && userAccessJson.length > 0) {
        //             $scope.userAccess = {};
        //             _.each(userAccessJson, function(noteObj) {
        //                 user_access = {};
        //                 _.each(noteObj.privilege, function(privObj) {
        //                     user_access[privObj.name.toLowerCase()] = privObj.status
        //                 })
        //                 $scope.userAccess[noteObj.feature_id] = user_access;
        //             })
        //         } else
        //             $state.go('dashboard')
        //     })
            /** @Author: Naveen Nazimudeen N  @Date: 2018-02-23 15:18:09  @Desc: For url authorisation --ends */
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Student Parent Mapping"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        $scope.showList = false
        $scope.filteredUsers = []
        this.userMgt = {}
        this.dataCount = []
        this.selectedIndex = 'userNames'
        this.userNamesEndorsed = [];
        self.sessions = []
        $scope.loading = true

        this.$onDestroy = () => {
            self.userNamesEndorsed = []
            self.userNames = []
            self.parentOnlyList = []
            self.xclasses = []
            self.batches = []
            self.curricula = []
            self.sessions = []
        }
        let schoolIdLocal = localStorageService.get('school_id')
        function loadSelections() {
            let loadObj = {
                school_id : schoolIdLocal
            }
            authService.callAPI("/v0/student_mapping/init", "POST", 
            {args : loadObj}, function (response) {
                $scope.loading = false
                if(!response.error){
                    let res = response.result.data.details.response
                    self.sessions = res ? res : []
                    _.defer(function() { $scope.$apply(); });;
                }
            })
        }
        loadSelections();
        $scope.$watch(function() {
            $scope.fileFiltered = $scope.$eval('studentParentMapping.userNames | filter : studentParentMapping.searchUser')
        })

        $scope.fileFilteredParents = [] //filter no results
        $scope.$watch(function() {
            $scope.fileFilteredParents = $scope.$eval('studentParentMapping.parentOnlyList | filter : studentParentMapping.searchMappedParent')
        })

        $scope.fileFilteredNotMapped = [] //filter no results
        $scope.$watch(function() {
            $scope.fileFilteredNotMapped = $scope.$eval('studentParentMapping.userNamesEndorsed | filter : studentParentMapping.searchUser')
        })

        this.getRoleDetails = (id) => {
            $scope.roleType = id;
        }
        this.getBatch = () => {
            self.batches = [];
            let loadObj = {
                classId : self.userMgt.classId,
                curriculumId : this.userMgt.curriculumId,
                sessionId : this.userMgt.sessionId,
                school_id : schoolIdLocal
            }
            authService.callAPI("/v0/student_mapping/getBatchFiltered", "POST", 
            {args : loadObj}, function (response) {
                if(!response.error){
                    let res = response.result.data.details.response
                    self.batches = res ? res : []
                    self.userMgt.batchId = undefined
                    $scope.loading = false
                    _.defer(function() { $scope.$apply(); });;
                }
            })

        }

        self.searchMappedStudents = () => {
            $scope.loading = true
            self.userNamesEndorsed = []
            self.userNames = []
            
            let load = {
                school_id : schoolIdLocal,
                userMgt : this.userMgt,
                FILE_UPLOAD_URL : CONSTANTS.FILE_UPLOAD_URL
            }
            authService.callAPI("/v0/student_mapping/searchMappedStudents", "POST", 
            {args : load}, function (response) {
                if(!response.error){
                    let res = response.result.data.details.response
                    console.log(res)
                    if (res) {
                        self.userNamesEndorsed = res.userNamesEndorsed
                        self.userNames = res.userNames
                    }
                    $scope.loading = false
                    _.defer(function() { $scope.$apply(); });
                }
            })
            $scope.showList = true
        }
        let paginateCount = $scope.parentCount / 100
        paginateCount = Math.ceil(paginateCount)


        $scope.paginatedParentCount = 0
        $scope.alreadyCount = self.parentOnlyList ? self.parentOnlyList.length : 0
        $scope.notMappedPages = []
        $scope.mappedPages = []
        $scope.notMappedParents = []
        $scope.mappedParents = []

        function search(data, fromPaginate, npSE) {
            let load = {
                school_id : schoolIdLocal,
                data : data,
                academics : self.userMgt,
                count : $scope.callCount,
                fromPaginate : fromPaginate
            }
            authService.callAPI("/v0/student_mapping/searchParentMappedOrNot", "POST", 
            {args : load}, function (response) {
                
                try{
                    $scope.loading = false
                    if(!response.error){
                        let res = response.result.data.details.response
                        if (res) {
                            self.parentOnlyList = res.parentOnlyList
                            if (!fromPaginate) {
                                $scope.parentCount = res.parentCount
                                $scope.paginatedParentCount = self.parentOnlyList.length
                                paginateCount = $scope.parentCount / 100
                                paginateCount = Math.ceil(paginateCount)
                            }
                            if ($scope.callCount == paginateCount) {
                                $scope.disableNext = true
                            } else {
                                $scope.disableNext = false
                            }
                            $scope.callCount++
                            if ($scope.callCount == 2) {
                                if (self.parentOnlyList.length < 100) {
                                    $scope.disableNext = true
                                } else {
                                    $scope.disableNext = false
                                }
                            }
                        }
                        if (data == '0') {
                            $scope.mappedParents.push(self.parentOnlyList)
                            $scope.mappedParents = _.flatten($scope.mappedParents)
                            $scope.mappedPages.push($scope.callCount)
                        } else {
                            $scope.notMappedParents.push(self.parentOnlyList)
                            $scope.notMappedParents = _.flatten($scope.notMappedParents)
                            $scope.notMappedPages.push($scope.callCount)
                        }
                        getCountShown($scope.callCount, data, npSE)
                        
                    }
                    _.defer(function() { $scope.$apply(); });
                }catch(e){
                    console.log(e)
                }
                
            })
        }
        self.searchParentMappedOrNot = (data, fromPaginate, npSE) => {
            self.showPagination = true
            $scope.loading = true
            self.mappedTrue = []
            self.mappedFalse = []
            self.parentOnlyList = []
                // if(npSE == "first" || npSE == "last"){

            //     search(data, fromPaginate, npSE)
            // }
            if (npSE == "pre") {
                $scope.callCount = $scope.callCount - 2
            }
            if (!$scope.callCount) {
                $scope.callCount = 1
            }
            if (!fromPaginate) {
                self.searchMappedParent = undefined
                $scope.callCount = 1
                $scope.paginatedParentCount = 0
                $scope.preCount = 0
            }
            // if($scope.callCount = 1){
            //     $scope.currentPage = 0
            // }


            

            if ($scope.callCount == 1) {
                $scope.disablePrev = true
            } else {
                $scope.disablePrev = false
            }
            if (paginateCount == $scope.callCount) {
                $scope.disableNext = true
            } else {
                $scope.disableNext = false
            }

            if (npSE == "first") {
                $scope.callCount = 1
            }
            let flag = false
            if (data == '0') {
                //     $scope.mappedParents = self.parentOnlyList
                $scope.users = $scope.mappedParents
                $scope.callCountArray = $scope.mappedPages
                flag = true
            } else {
                //     $scope.notMappedParents = self.parentOnlyList
                $scope.users = $scope.notMappedParents
                $scope.callCountArray = $scope.notMappedPages

            }
            $scope.callCountArray = _.uniq($scope.callCountArray)
            
            if (!$scope.users || !$scope.users.length) {
                search(data, fromPaginate, npSE)
            } else {
                if (!$scope.callCountArray || !$scope.callCountArray.length) {
                    search(data, fromPaginate, npSE)
                } else {

                    $scope.loading = false
                    if ($scope.callCountArray.indexOf($scope.callCount) !== -1) {
                        self.parentOnlyList = _.filter($scope.users, function(one) {
                                return one.count == $scope.callCount && one.mapped == flag
                            })
                            // console.log($scope.callCount)s
                        if (!self.parentOnlyList.length) {
                            $scope.loading = true
                            search(data, fromPaginate, npSE)
                        } else {

                            self.parentOnlyList = _.filter($scope.users, function(one) {
                                return one.count == $scope.callCount && one.mapped == flag
                            })
                            let paginateCount = $scope.parentCount / 100
                            paginateCount = Math.ceil(paginateCount)
                            if ($scope.callCount == paginateCount) {
                                $scope.disableNext = true
                            } else {
                                $scope.disableNext = false
                            }
                            $scope.callCount++
                                if ($scope.callCount == 2) {
                                    if (self.parentOnlyList.length < 100) {
                                        $scope.disableNext = true
                                    } else {
                                        $scope.disableNext = false
                                    }
                                }
                            getCountShown($scope.callCount, data, npSE)
                        }
                    } else {
                        search(data, fromPaginate, npSE)
                    }
                }
            }
            // getCountShown($scope.callCount, data, npSE)


        }

        function getCountShown(callCount, data, npSE) {


            let users = []
            let flag = false
            if (data == '0') {
                users = []
                users = $scope.mappedParents
                flag = true
            } else {
                users = []
                users = $scope.notMappedParents

            }
            callCount = callCount - 1
            let cnt = 0
                // if(npSE == "pre"){
                //     callCount = callCount - 1
                // }

            if (callCount < 1) {
                callCount = 1
            }
            users = _.uniq(users, false, function(o) {
                return o._id
            })

            // console.log(callCount)
            let counttWiseDoc = _.groupBy(users, function(val) {
                    return val.count;
                })
                // console.log(counttWiseDoc)
            let arr = []
            for (let i = callCount; i >= 1; i--) {
                arr.push(i)
            }
            let keys = Object.keys(counttWiseDoc)
            _.each(arr, function(key) {
                let len = counttWiseDoc[key] ? counttWiseDoc[key].length : 0
                    // console.log(counttWiseDoc[key])
                cnt = cnt + len
            })
            $scope.paginatedParentCount = cnt


            /*if(npSE == 'pre'){
                callCount = callCount - 2    
            }*/
            // let subjectWiseDoc = _.groupBy(users, function (val) {
            //     return val.academic_details.subject_id;
            // })
        }
        self.showNameSearch = false
        self.searchParentMappedOrNotByName = (data, fromPaginate, npSE) => {
            self.showPagination = false
            $scope.users = []
            $scope.mappedParents = []
            $scope.notMappedParents = []
            $scope.notMappedPages = []
            $scope.mappedPages = []
            $scope.callCountArray = []
            $scope.paginatedParentCount = 0
            $scope.callCount = 1
            self.parentOnlyList = []

            if (!self.searchMappedParent || !self.searchMappedParent.length || self.searchMappedParent == '') {
                self.searchParentMappedOrNot(data, false, npSE)
            } else {
                $scope.loading = true
                let loadObj = {
                    school_id : schoolIdLocal,
                    data : data,
                    academics : this.userMgt,
                    count : $scope.callCount,
                    fromPaginate : fromPaginate,
                    nameString : self.searchMappedParent
                }
                authService.callAPI("/v0/student_mapping/searchParentMappedOrNotByName", "POST", 
                {args : loadObj}, function (response) {
                    if(!response.error){
                        $scope.loading = false
                        let res = response.result.data.details.response
                        if (res) {
                            self.parentOnlyList = res
                        }
                    }
                    self.showNameSearch = true
                    _.defer(function() { $scope.$apply(); });
                })
                // Meteor.call("searchParentMappedOrNotByName",
                //  Session.get('school_id'), data, this.userMgt, $scope.callCount, fromPaginate, self.searchMappedParent, function(err, res) {
                //     $scope.loading = false
                //     if (res) {

                //         self.parentOnlyList = res


                //     }
                //     self.showNameSearch = true
                //     _.defer(function() { $scope.$apply(); });
                // })
            }


        }
        self.clearParent = (data) => {
            self.searchMappedParent = undefined
            self.searchParentMappedOrNot(data, false, {})
        }

        $scope.callCount = 1


        // self.clearSelection = () => {
        //     Meteor.call("searchParentMappedOrNotCount", Session.get('school_id'), this.userMgt, function(err, res){
        //         $scope.loading = false
        //         if(res){
        //             self.notMappedParentCount = res.notMappedParentCount ? res.notMappedParentCount : 0
        //             self.mappedParentCount = res.mappedParentCount ? res.mappedParentCount : 0
        //         }
        //         _.defer(function() { $scope.$apply(); });
        //     })
        // }
        

        this.getClass = () => {
            // $scope.loading = true
            self.xclasses = [];
            let loadObj = {
                curriculumId : this.userMgt.curriculumId,
                sessionId : this.userMgt.sessionId,
                school_id : schoolIdLocal
            }
            authService.callAPI("/v0/student_mapping/getClassFiltered", "POST", 
            {args : loadObj}, function (response) {
                if(!response.error){
                    let res = response.result.data.details.response
                    if (res) {
                        self.xclasses = res
                    } else {
                        self.xclasses = []
                    }
                    self.userMgt.classId = undefined
                    self.userMgt.batchId = undefined
                    self.showBatchName = []
                    $scope.loading = false
                    _.defer(function() { $scope.$apply(); });;
                }
            })
        }

        this.getCuriculum = () => {
            // $scope.loading = true
            
            let loadObj = {
                school_id : schoolIdLocal,
                sessionId : this.userMgt.sessionId
            }
            authService.callAPI("/v0/student_mapping/getCuriculumFiltered", "POST", 
            {args : loadObj}, function (response) {
                if(!response.error){
                    let res = response.result.data.details.response
                    if (res) {
                        self.curricula = res
                    } else {
                        self.curricula = []
    
                    }
                    self.userMgt.curriculumId = undefined
                    self.userMgt.classId = undefined
                    self.userMgt.batchId = undefined
                    self.showClassName = []
                    self.showBatchName = []
                    $scope.loading = false
                    _.defer(function() { $scope.$apply(); });;
                }
            })
            // Meteor.call("getCuriculumFiltered", this.userMgt.sessionId, Session.get('school_id'), function(err, res) {
            //     if (res) {
            //         self.curricula = res
            //     } else {
            //         self.curricula = []

            //     }

            //     self.userMgt.curriculumId = undefined
            //     self.userMgt.classId = undefined
            //     self.userMgt.batchId = undefined
            //     self.showClassName = []
            //     self.showBatchName = []
            //     $scope.loading = false
            //     _.defer(function() { $scope.$apply(); });;
            // })

        }

        this.getUsersListsforMap = () => {

            $scope.showList = true

            let conditions = {
                role_ids: {
                    $in: ['student']
                },
                school_id: schoolIdLocal,
                status: "active"
            }
            if (this.userMgt.sessionId) {

                conditions['session_id'] = this.userMgt.sessionId
            }
            if (this.userMgt.curriculumId) {
                conditions['curriculum_id'] = this.userMgt.curriculumId
            }
            if (this.userMgt.classId) {

                conditions['class_id'] = this.userMgt.classId
            }
            if (this.userMgt.batchId) {

                conditions['batch_id'] = this.userMgt.batchId
            }

            $scope.loadingUser = true


            var confirm = $mdDialog.confirm()
                .title('')
                .textContent('Are you sure to map ?')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function() {
                $scope.loading = true
                conditions['FILE_UPLOAD_URL'] = CONSTANTS.FILE_UPLOAD_URL
                authService.callAPI("/v0/student_mapping/mapStudentWithParent", "POST", 
                {args : conditions}, function (response) {
                    if(!response.error){
                        let result = response.result.data.details.response
                        let res = result.mapped
                        res = res ? res : "0"
                        toastr.success(res + " students mapped")
                        $scope.selectedTab = 0;
                        if (result.userNamesEndorsed) {
                            self.userNamesEndorsed = result.userNamesEndorsed
                        }
                        if (result.userNames) {
                            self.userNames = result.userNames
                        }
                        
                    }else{
                        toastr.error(response.error.error)
                    }
                    $scope.loading = false
                    _.defer(function() { $scope.$apply(); });;
                })
            })
        }



        self.viewNotMappedStatus = () => {
            let conditions = {
                school_id: schoolIdLocal
            }
            authService.callAPI("/v0/student_mapping/personGroupByStudents", "POST", 
                {args : conditions}, function (response) {
                    console.log(response)
                    if(!response.error){
                        let res = response.result.data.details.response
                        self.dataCount = [];
                        _.each(res, function(count) {
                            self.dataCount.push(count)
                        })
                        $mdDialog.show({
                            controller: ['$scope',  '$state', '$stateParams', 'data', '$mdMedia', '$mdDialog', viewNotMappedStatusController],
                            locals: {
                                data: self.dataCount
                            },
                            template: PreviewViewNotMappedStatus,
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                        })
                    }
                    
            })
            // Meteor.call('personGroupByStudents', Session.get('school_id'), function(err, res) {
            //     if (err) {
            //         toastr.success("server not found")
            //     } else {
            //         self.dataCount = [];
            //         _.each(res, function(count) {
            //             self.dataCount.push(count)
            //         })
            //     }
            //     $mdDialog.show({
            //         controller: ['$scope',  '$state', '$stateParams', 'data', '$mdMedia', '$mdDialog', viewNotMappedStatusController],
            //         locals: {
            //             data: self.dataCount
            //         },
            //         templateUrl: PreviewViewNotMappedStatus,
            //         parent: angular.element(document.body),
            //         clickOutsideToClose: true,
            //     })
            // })
        }
    }
}
class viewNotMappedStatusController {
    constructor($scope, $state, $stateParams, data, $mdMedia, $mdDialog) {
        'ngInject';
        $scope.notMappedStatusArray = data
        $scope.hide = function() {
            $mdDialog.hide();
        };
        $scope.cancel = function() {
            $mdDialog.cancel();
        };

    }
}
export default studentParentMapping;


// WEBPACK FOOTER //
// ./src/app/student_mapping/controllers/mappingController.js